































































































/* api */
import GetImageApi from '@/app/model/api/getImageApi'
/* module */
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import Session from '@/app/module/session'

@Component
export default class FieldImg extends Vue {
  private showImgModal: boolean = false;
  private originalImagePath: string = ''
  private renderImg: boolean = false
  private isLoading: boolean = false
  private displayImg: string = ''
  private isActive: boolean = false

  @Prop() private plantingId!: number
  @Prop() private cropImageId!: number
  @Prop() private date!: string
  @Prop() private imgPath!: string

  private get changeImgPath (): string {
    return this.imgPath
  }

  @Watch('changeImgPath')
  onChangeImgPath (path: string) {
    this.getDefaultImg()
  }

  private get changeCropImgId (): number {
    return this.cropImageId
  }

  @Watch('changeCropImgId')
  onChangeCropImgId (id: number) {
    this.getDefaultImg()
  }

  created () {
    this.getDefaultImg()
  }

  private async getDefaultImg () {
    if (this.cropImageId === 0 && parseInt(this.date) === 0) {
      this.displayImg = this.imgPath
    } else if ((this.imgPath !== '' && this.imgPath !== undefined) || this.cropImageId !== undefined) {
      let body: any = {
        planting_id: this.plantingId,
        date: this.date,
        type: ''
      }

      if (this.cropImageId !== undefined) {
        body.crop_image_id = this.cropImageId
      }

      const result = await GetImageApi.getImageData(body)
      this.displayImg = String(result)
    } else {
      this.isActive = true
      this.displayImg = require('@/assets/icon/ico_cultivation2.png')
    }
  }

  /* モーダルのオリジナル画像を取得 */
  private async showModal (path: string) {
    this.showImgModal = true
    if (this.cropImageId === 0 && parseInt(this.date) === 0) {
      this.originalImagePath = this.imgPath
    } else if ((this.imgPath !== '' && this.imgPath !== undefined) || this.cropImageId !== undefined) {
      this.isLoading = true
      let body: any = {
        planting_id: this.plantingId,
        date: this.date,
        type: 'original'
      }

      if (this.cropImageId !== undefined) {
        body.crop_image_id = this.cropImageId
      }

      const result = await GetImageApi.getImageData(body)
      this.isLoading = false
      this.originalImagePath = String(result)
    } else {
      this.isActive = true
      this.originalImagePath = require('@/assets/icon/ico_cultivation2.png')
    }
  }
}
